import request from '@/utils/request'

// 获取关注列表
export function getFollowList() {
  return request({
    url: '/api/user/follow/list',
    method: 'get'
  })
}

// 关注用户
export function followUser(userId) {
  return request({
    url: '/api/user/follow',
    method: 'post',
    data: { userId }
  })
}

// 取消关注
export function unfollowUser(userId) {
  return request({
    url: '/api/user/follow',
    method: 'delete',
    data: { userId }
  })
}

// 获取用户信息
export function getUserInfo(userId) {
  return request({
    url: `/api/user/info/${userId}`,
    method: 'get'
  })
}

// 获取用户统计信息
export function getUserStats(userId) {
  return request({
    url: `/api/user/stats/${userId}`,
    method: 'get'
  })
}
// 艾特用户列表
export function fetchUser(params) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: params
  })
}

// 设置锁屏密码
export function setLockScreenPassword(data) {
  return request({
    url: '/v1/user/lockScreen/password',
    method: 'post',
    data: data
  })
}

// 修改锁屏密码
export function updateLockScreenPassword(data) {
  return request({
    url: '/v1/user/lockScreen/password',
    method: 'put',
    data: data
  })
}

// 验证锁屏密码
export function verifyLockScreenPassword(data) {
  return request({
    url: '/v1/user/lockScreen/unlock',
    method: 'post',
    data: data
  })
}

// 获取锁屏密码状态
export function getLockScreenPasswordStatus() {
  return request({
    url: '/v1/user/lockScreen/status',
    method: 'get'
  })
}

// 重置锁屏密码（通过验证登录密码）
export function resetLockScreenPassword(data) {
  return request({
    url: '/v1/user/lockScreen/reset',
    method: 'post',
    data: data
  })
}

